import { Message } from "@arco-design/web-vue";
interface IMessage {
  // type?: "success" | "error" | "info" | "warning" | "full-loading";
  // content?: ReactNode; // 提示内容、 默认值: -
  // icon?: string | ReactNode; // 自定义图标、 默认值: -

  position?: "top" | "bottom"; // 消息的位置
  showIcon?: boolean; // 是否显示图标， 默认值：false
  closable?: boolean; // 是否显示关闭按钮， 默认值：false
  resetOnHover?: boolean; // 设置鼠标移入后不会自动关闭， 默认值：false
  duration?: number; // 消息显示的持续时间

  handleCancel?: (id?: number | string) => void; // 关闭时的回调函数、 默认值: -
}

function msgConfig(props?: IMessage) {
  return {
    // icon: props?.icon && typeof props?.icon == "string" ? generateIcon(props?.icon) : props?.icon,
    position: props?.position ?? "top",
    showIcon: props?.showIcon ?? false,
    closable: props?.closable ?? false,
    resetOnHover: props?.resetOnHover ?? false,
    duration: props?.duration ?? 3000,
    onClose: () => {
      props?.handleCancel?.();
    }
  };
}

export class Msg {
  static success(content: string = "操作成功", props?: IMessage) {
    Message?.["success"]({
      content: content ?? "已取消当前操作",
      ...msgConfig(props)
    });
  }

  static warning(content: string = "操作成功", props?: IMessage) {
    Msg.destroy();
    Message?.["warning"]({
      content: content ?? "已取消当前操作",
      ...msgConfig(props)
    });
  }
  static error(content: string = "操作成功", props?: IMessage) {
    Msg.destroy();
    Message?.["error"]({
      content: content ?? "已取消当前操作",
      ...msgConfig(props)
    });
  }

  static loading(content: string = "操作成功", props?: IMessage) {
    Msg.destroy();
    Message?.["loading"]({
      content: content ?? "已取消当前操作",
      ...msgConfig(props)
    });
  }

  static info(content: string = "操作成功", props?: IMessage) {
    Msg.destroy();
    Message?.["info"]({
      content: content ?? "已取消当前操作",
      ...msgConfig(props)
    });
  }

  static destroy() {
    Message?.clear();
  }
}
